module.exports = __webpack_public_path__ + "img/最外侧边框.994bac8f.png";